import ListTravels from '@/requests/travels/user/listTravels';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/requests/$id/travels/')({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: '/login' });
    }
  },
  component: UserTravelsList,
});

function UserTravelsList() {
  const { id } = Route.useParams();
  
  return (
    <div className="container mx-auto py-6">
      <ListTravels userId={id} />
    </div>
  );
}